<template>
  <div class="greeting-container-inner">
    <h5 class="mb-0 greeting-title">
      <span class="greeting-prefix">{{ greetingText }},</span>
      <span class="user-name"> {{ displayName }}</span>
    </h5>
    <p class="mb-0 font-roboto datetime-text">
      <i class="fa fa-clock-o datetime-icon" aria-hidden="true"></i>
      <span>{{ currentDateTime }}</span>
    </p>
  </div>
</template>

<script>
export default {
  data() {
    return {
      firstName: '',
      lastLame: '',
      businessName: '',
      userCategory: '',
      currentDateTime: '',
      updateInterval: null
    };
  },
  computed: {
    greetingText() {
      const hour = new Date().getHours();
      if (hour >= 5 && hour < 12) {
        return 'Good Morning';
      } else if (hour >= 12 && hour < 17) {
        return 'Good Afternoon';
      } else if (hour >= 17 && hour < 22) {
        return 'Good Evening';
      } else {
        return 'Welcome';
      }
    },
    displayName() {
      if (this.userCategory === 'DISTRIBUTOR') {
        return this.businessName || 'Distributor';
      }
      return this.firstName || 'User';
    }
  },
  created() {
    this.firstName = localStorage.getItem('first_name') || '';

    // Get last name, but force it to null if it's literally just "null" text or empty
    const rawLastName = localStorage.getItem('last_name');
    this.lastLame = (rawLastName && rawLastName !== 'null') ? rawLastName : '';

    this.businessName = localStorage.getItem('business_name') || '';
    this.userCategory = localStorage.getItem('user_label') || '';

    this.updateDateTime();
    this.startClock();
  },
  beforeUnmount() {
    if (this.updateInterval) {
      clearInterval(this.updateInterval);
    }
  },
  methods: {
    updateDateTime() {
      const now = new Date();
      const dateOptions = { year: 'numeric', month: 'long', day: 'numeric' };
      const formattedDate = now.toLocaleDateString('en-US', dateOptions);

      const timeOptions = {
        hour: '2-digit',
        minute: '2-digit',
        second: '2-digit',
        hour12: true
      };
      const formattedTime = now.toLocaleTimeString('en-US', timeOptions);
      this.currentDateTime = `${formattedDate} | ${formattedTime}`;
    },
    startClock() {
      this.updateInterval = setInterval(this.updateDateTime, 1000);
    }
  }
};
</script>

<style scoped>
.greeting-container-inner {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.greeting-title {
  font-size: 20px;
  font-weight: 700;
  color: #2b303b;
  letter-spacing: -0.2px;
  display: flex;
  align-items: center;
  line-height: 1.2;
}

.greeting-prefix {
  font-weight: 500;
  color: #5c6873;
}

.user-name {
  color: #1a335e; /* Deep navy tone matching LAUGFS theme */
  font-weight: 700;
  margin-left: 4px;
}

.datetime-text {
  font-size: 13px;
  color: #7e8b9b;
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 500;
  margin-top: 2px;
}

.datetime-icon {
  color: #b0bac5;
  font-size: 12px;
}

@media (max-width: 768px) {
  .greeting-title {
    font-size: 17px;
  }
  .datetime-text {
    font-size: 11px;
  }
}
</style>